async function editUserEmail(newEmail: String): Promise<number> {
  try {
      const url = `https://ruuf-backend.online/user`;
      const timeout = new Promise<Response>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000),
      );
      const response = await Promise.race([
        fetch(url, {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: newEmail }),
        }),
        timeout,
      ]);

      if (!(response instanceof Response)) {
        throw response;
      }
      if (response.status === 200) {
        console.log("Email changed succesfully: ", newEmail);
        return 1;
      } else {
        throw new Error("Could not Change Email");
      }
    } catch (error) {
      console.error("Error changing Email:", error);
      return 0;
    }
}

export default editUserEmail;
